import React from 'react';
import { Switch } from "react-router-dom";
import { AuthedRoutes } from '../components/AuthedRoutes'
import PowerSkillTest from '../pages/powerskill/powerskill-test'

export const powerSkillRoutes = () => {
  return (
    <Switch>
      <AuthedRoutes 
        menu='competency'
        exact 
        path={"/powerskill"} 
        component={PowerSkillTest}
        showBreadcrumb={false}
        headerTitle="PowerSkills Test"
        noPadding
      ></AuthedRoutes>
    </Switch>
  )
}
